/* Presentation only. Shrine owns cart requests, quantities, errors and checkout. */
(() => {
  if (!document.body.classList.contains('ve-page')) return;
  const icon = path => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">${path}</svg>`;
  const bag = icon('<path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/>');
  const shield = icon('<path d="M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6l-9-4Z"/><path d="m8 12 3 3 5-6"/>');
  const lock = '<svg class="ve-cart-lock" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  function decorate() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('ve-cart-design');
    const heading = drawer.querySelector('.drawer__heading');
    if (heading && !heading.querySelector('.ve-cart-heading-label')) {
      const title = heading.textContent.trim().replace(/^Cart\s*[•·]?\s*/i, '');
      heading.replaceChildren();
      heading.insertAdjacentHTML('beforeend', bag);
      const text = document.createElement('span'); text.className = 've-cart-heading-label'; text.textContent = title;
      heading.append(text);
    }
    drawer.querySelectorAll('cart-remove-button button').forEach(button => {
      if (button.textContent.trim() !== 'Remove') button.textContent = 'Remove';
    });
    const footer = drawer.querySelector('.drawer__footer');
    if (!footer || drawer.classList.contains('is-empty')) return;
    if (!footer.querySelector('.ve-cart-trust')) {
      const trust = document.createElement('div'); trust.className = 've-cart-trust';
      trust.innerHTML = `<span>${bag}Discreet Shipping</span><span>${shield}90-Day Guarantee</span>`;
      footer.prepend(trust);
    }
    const checkout = footer.querySelector('#CartDrawer-Checkout');
    const label = checkout?.querySelector('.button__label');
    const total = footer.querySelector('.cart-drawer__totals__row__money')?.textContent.trim();
    if (label) {
      const title = total ? `CHECKOUT — ${total}` : 'CHECKOUT';
      if (label.dataset.veTitle !== title) {
        label.innerHTML = `${lock}<span>${title}</span>`; label.dataset.veTitle = title;
      }
    }
    if (checkout && !footer.querySelector('.ve-cart-payment-note')) {
      const note = document.createElement('div');
      note.innerHTML = '<p class="ve-cart-free-shipping">FREE SHIPPING</p><div class="ve-cart-payment-note"><span>Secure payments</span><span>90-day money-back guarantee</span></div>';
      checkout.closest('.cart__ctas').after(note);
    }
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return; pending = true;
    requestAnimationFrame(() => { pending = false; observer.disconnect(); decorate(); observe(); });
  });
  function observe() { const drawer = document.querySelector('cart-drawer'); if (drawer) observer.observe(drawer, {childList:true,subtree:true}); }
  function init() { decorate(); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
